module.exports = __webpack_public_path__ + "img/teacher.d123f292.png";